import React, { Component } from 'react';
import { withScriptjs, withGoogleMap, GoogleMap, InfoWindow, Marker } from "react-google-maps";
import Aux from '../../hoc/Auxiliary/Auxiliary';
import carIcon from '../../assets/images/car-small-icon.png';
import carGreyIcon from '../../assets/images/mark-grey-small-icon.png';

const { MarkerWithLabel } = require("react-google-maps/lib/components/addons/MarkerWithLabel");

class Map extends Component {

  constructor(props) {
    super(props);
    this.map = React.createRef();
  }

  formatDatePretty = (date) => {
    if (date === undefined || date === null) {
      return null;
    }
    return date.substring(11, 16) + " " + date.substring(8, 10) + "/" + date.substring(5, 7) + "/" + date.substring(2, 4);
  }

  componentDidUpdate(prevProps, prevState) {
    if ((!prevProps.markers && this.props.markers) ||
          (!prevProps.mapPoints && this.props.mapPoints) ||
          (!prevProps.mapOrigin && this.props.mapOrigin)) {
      const bounds = new window.google.maps.LatLngBounds();
      this.props.markers.forEach(position => {
        let place = { lat: position.latitude, lng: position.longitude };
        bounds.extend(place);
      });
      this.props.mapPoints.forEach(position => {
        let place = { lat: position.lat, lng: position.lng };
        bounds.extend(place);
      });
      if (this.props.mapOrigin) {
        let place = { lat: this.props.mapOrigin.lat, lng: this.props.mapOrigin.lng };
        bounds.extend(place);
      }
      this.map.current.fitBounds(bounds);
    }
  }

  render() {
    let center = { lat: 48.3794, lng: 31.1656 };
    if (this.props.markers && this.props.markers.length > 0) {
      center = {
        lat: this.props.markers[this.props.markers.length - 1].latitude,
        lng: this.props.markers[this.props.markers.length - 1].longitude
      };
    }

    return (
      <GoogleMap
        defaultZoom={6}
        ref={this.map}
        onLoad={this.loadHandler}
        onMapMounted={this.loadHandler}
        defaultCenter={center} >
        {
          this.props.mapOrigin ?
          <Marker
            position={{ lat: this.props.mapOrigin.lat, lng: this.props.mapOrigin.lng }}
            labelAnchor={{ x: 62.5 + 6, y: 75 }}
            icon={{url: this.props.mapOrigin.icon}}
            onClick={(ev) => this.props.pointInfoWindow(-1, true)}>
            {
              this.props.mapOrigin.infoWindow ?
              <InfoWindow
                style={{color: "#fff", backgroundColor: "#000", fontSize: "12px", padding: "12px"}}
                onCloseClick={(ev) => this.props.pointInfoWindow(-1, false)}>
                <div>
                  <div>1. {this.props.mapOrigin.title}</div>
                </div>
              </InfoWindow>
            : null
            }
          </Marker>
          : null
        }
        {
          this.props.mapPoints && this.props.mapPoints.length > 0 ?
          this.props.mapPoints.map( (position, index) => {
            return (
              <Marker
                key={index}
                position={{ lat: position.lat, lng: position.lng }}
                labelAnchor={{ x: 62.5 + 6, y: 75 }}
                onClick={(ev) => this.props.pointInfoWindow(index, true)}
                icon={{url: position.icon}} >
                {
                  position.infoWindow ?
                  <InfoWindow
                    onCloseClick={(ev) => this.props.pointInfoWindow(index, false)}>
                    <div>
                      {
                        position.complete ?
                        <div>{index + 2}. {position.title}</div>
                        :
                        <h4 style={{margin: "0"}}>{index + 2}. {position.title}</h4>
                       }
                    </div>
                  </InfoWindow>
                : null
                }
              </Marker>
            )
          })
          : null
        }
        {
          this.props.markers ?
          this.props.markers.map( (position, index) => {
            return (
              <Aux>
                <Marker
                  key={index}
                  position={{ lat: position.latitude, lng: position.longitude }}
                  labelAnchor={{ x: 54, y: 75 }}
                  onClick={(ev) => this.props.infoWindow(index, true)}
                  icon={{url: index < this.props.markers.length - 1 ? carGreyIcon : carIcon }}>
                  {
                    position.infoWindow ?
                    <InfoWindow
                      style={{color: "#fff", backgroundColor: index < this.props.markers.length - 1 ? "#262626" : "#000", fontSize: "12px", padding: "12px"}}
                      onCloseClick={(ev) => this.props.infoWindow(index, false)}>
                      <div>
                        <div>{this.formatDatePretty(position.locationDate)}</div>
                      </div>
                    </InfoWindow>
                  : null
                  }
                </Marker>
              </Aux>
            )
          })
          : null
        }
      </GoogleMap>
    );
  }
}

export default withScriptjs(withGoogleMap(Map));



// WEBPACK FOOTER //
// ./src/components/Map/Map.js